export var SystemRoleV2Enum;
(function (SystemRoleV2Enum) {
    SystemRoleV2Enum["GOPARROT_SUPER_ADMIN"] = "goparrot_super_admin";
    SystemRoleV2Enum["MERCHANT_SUPER_ADMIN"] = "merchant_super_admin";
    SystemRoleV2Enum["STORE_ADMIN"] = "store_admin";
    SystemRoleV2Enum["STORE_OPERATIONS"] = "store_operations";
    SystemRoleV2Enum["STORE_CASHIER"] = "store_cashier";
    SystemRoleV2Enum["MERCHANT_OPERATOR"] = "merchant_operator";
    SystemRoleV2Enum["MERCHANT_ADVERTISER"] = "merchant_advertiser";
})(SystemRoleV2Enum || (SystemRoleV2Enum = {}));
//# sourceMappingURL=SystemRoleV2Enum.js.map